// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import React from "react";
import { List, Flex } from "antd";
import { RightOutlined } from "@ant-design/icons";

// -----------------------------------------------------------------------------
// Components and Styles
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const AccountCard = ({ onClick, icon, header, text, customColor, name }) => {
	return (
		<List.Item
			extra={
				<Flex justify="flex-start" align="center" style={{ width: 32, height: 32 }}>
					<RightOutlined />
				</Flex>
			}
			style={{ cursor: "pointer" }}
			onClick={onClick}
			data-id={name}
		>
			<List.Item.Meta avatar={icon} title={header} description={text} />
		</List.Item>
	);
};

export default AccountCard;

